__turbopack_context__.v({
  "Tooltip": "copy-id-module__2-x-rW__Tooltip",
});
